module.exports = __webpack_public_path__ + "static/media/nikon_iphones.574614c0.png";